import type { UnitOfMeasurement } from '../../gql';

import { randUuid } from '@ngneat/falso';

const dummyWeightUnits = [
    { name: 'Gram', symbol: 'g' },
    { name: 'Kilogram', symbol: 'kg' },
    { name: 'Ounce', symbol: 'oz' },
    { name: 'Pound', symbol: 'lb' },
];

const dummyLengthUnits = [
    { name: 'Centimeter', symbol: 'cm' },
    { name: 'Foot', symbol: 'ft' },
    { name: 'Inch', symbol: 'in' },
    { name: 'Meter', symbol: 'm' },
    { name: 'Millimeter', symbol: 'mm' },
    { name: 'Yard', symbol: 'yd' },
];

const dummyVolumeUnits = [
    { name: '#', symbol: '#' },
    { name: 'Centiliter', symbol: 'cl' },
    { name: 'Cubic Meter', symbol: 'm³' },
    { name: 'Deciliter', symbol: 'dl' },
    { name: 'Hectoliter', symbol: 'hl' },
    { name: 'Lignes', symbol: 'ln' },
    { name: 'Liter', symbol: 'l' },
    { name: 'Milliliter', symbol: 'ml' },
    { name: 'Pieces', symbol: 'pcs' },
    { name: 'Square Centimeter', symbol: 'cm²' },
    { name: 'Square Inch', symbol: 'in²' },
    { name: 'Square Meter', symbol: 'm²' },
    { name: 'Square Yard', symbol: 'yd²' },
];

const dummyUnitsOfMeasurement = [
    ...dummyWeightUnits,
    ...dummyLengthUnits,
    ...dummyVolumeUnits,
];

const mockUnitOfMeasurement = (
    override?: Partial<UnitOfMeasurement>,
    type?: 'length' | 'volume' | 'weight'
): UnitOfMeasurement => {
    let targetArray = dummyUnitsOfMeasurement;
    if (type === 'weight') targetArray = dummyWeightUnits;
    if (type === 'length') targetArray = dummyLengthUnits;
    if (type === 'volume') targetArray = dummyVolumeUnits;
    const dummyUnit =
        targetArray[Math.floor(Math.random() * targetArray.length)];
    return {
        symbol: dummyUnit.symbol,
        unitOfMeasurementName: dummyUnit.name,
        unitOfMeasurementPublicId: randUuid(),
        unitOfMeasurementTypePublicId: randUuid(),
        ...override,
        ['__typename']: 'UnitOfMeasurement',
    };
};

export { mockUnitOfMeasurement };
